export default __webpack_public_path__ + "static/Денежный поток 11-4611486a9b2858982b68c42d07c33cac.jpg";